import Translations from '@/utils/Translations';
import Vue from 'vue';

class KeyValue {
    Items: KeyValueItem[] = [
        new KeyValueItem(0, 'yield', 'Avkastning'),
        new KeyValueItem(1, 'operatingMargin', 'Rörelsemarginal'),
        new KeyValueItem(2, 'growth', 'Tillväxt'),
        new KeyValueItem(3, 'longTerm', 'Framtidsutsikter'),
        new KeyValueItem(4, 'solidity', 'Soliditet'),
        new KeyValueItem(5, 'workingCapitalPct', 'Rörelsekapital i % av omsättning'),
        new KeyValueItem(6, 'financialStrength', 'Finansiell styrka'),
        new KeyValueItem(7, 'quickRatio', 'Kassalikviditet'),
        new KeyValueItem(8, 'interestCoverage', 'Räntetäckningsgrad'),
        new KeyValueItem(9, 'shortTerm', 'Kortsiktig beredskap'),
        new KeyValueItem(10, 'riskBuffer', 'Riskbuffert'),
        new KeyValueItem(11, 'returnOnCapital', 'Räntabilitet på eget kapital'),
    ];

    ByIndex(i: number): KeyValueItem {
        return this.Items[i];
    }

    ByKey(key: string): KeyValueItem | undefined {
        return this.Items.find( (x) => x.key === key );
    }
}

class KeyValueItem {
    index: number;
    key: string;
    name: string;

    constructor(index: number, key: string, name: string) {
        this.index = index;
        this.key = key;
        this.name = name;
    }

    Name(): string {
        return this.t(this.name);
    }

    Value(ranks: any): number {
        return ranks[this.key];
    }

    KeyFigure(kv: any): string {
        switch (this.index) {
            case 1:
            case 2:
            case 4:
            case 5:
            case 7:
            case 10:
            case 11: return (Vue as any).options.filters.P(kv[this.key] / 100.0);
            case 8: return (Vue as any).options.filters.GGR(kv.interestCoverage) + Vue.prototype.$t(' ggr');
            default:
                return '';
        }
    }

    Definition(): string {
        switch (this.index) {
            case 1:
                return this.t('Rörelseresultat efter avskrivningar i procent av nettoomsättningen. Nyckeltalet anger hur stor andel i procent av varje försäljningskrona som blir kvar för att täcka räntor, skatt samt skapa vinst.');
            case 2:
                return this.t('Procentuell förändring (justerad till tolvmånadersperiod) mellan föregående och innevarande års nettoomsättning. Nyckeltalet visar hur mycket företaget ökar eller minskar sin försäljning.');
            case 4:
                return this.t('Justerat eget kapital (eget kapital + beskattad del av obeskattade reserver) i procent av balansomslutningen. Nyckeltalet visar på bolagets finansiella stabilitet och långsiktiga överlevnadsförmåga.');
            case 5:
                return this.t('Omsättningstillgångar minskat med kortfristiga skulder i procent av nettoomsättningen. Nyckeltalet används bl.a. för att uppskatta bolagets kapitalbehov vid en expansion.');
            case 7:
                return this.t('Omsättningstillgångar exklusive lager och pågående arbete i procent av kortfristiga skulder. Nyckeltalet visar på bolagets betalningsförmåga på kort sikt.');
            case 8:
                return this.t('Rörelseresultat efter avskrivningar plus finansiella intäkter som multipel av finansiella kostnader. Nyckeltalet anger vilken förmåga bolaget har att täcka sina räntekostnader.');
            case 10:
                return this.t('Skillnaden i procent mellan avkastning på totalt kapital och genomsnittlig skuldränta. Nyckeltalet visar med hur mycket bolagets totala avkastning överstiger de räntekostnader de betalar.');
            case 11:
                return this.t('Resultat efter finansiella intäkter och kostnader i procent av justerat eget kapital (eget kapital + beskattade del av obeskattade reserver). Nyckeltalet visar bolagets avkastning på ägarnas insatta kapital.');
            default:
                return '';
        }
    }

    t(term: string): string {
        return Translations.GetTranslation(term);
    }
}

export default new KeyValue();
